import { createFormularioApi } from "@/contexts/fiscalizacao/formulario/api/formularioApi";
import { FormularioRespostaControle } from "@/contexts/fiscalizacao/formulario/model/FormularioRespostaControle";
import {
  formularioControleRespostaActions,
  getCountMunicipiosSynced,
  getFormularioControleRespostaIsSynced,
  getFormularioControleRespostaSynced,
  getMunicipiosSincronizados,
} from "@/contexts/fiscalizacao/formulario/store/formularioControleRespostaSlice";
import { useNetworkStatus } from "@/shared/hooks/useNetworkStatus";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";

export const useFormularioRespostaControle = () => {
  const { isOnline } = useNetworkStatus();
  const { user } = useAuth();
  const formularioApi = createFormularioApi(user?.access_token);
  const appDispatch = useDispatch();
  const listaFormularioControleResposta = useSelector(
    getFormularioControleRespostaSynced
  );
  const { sync, removeMunicipio } = formularioControleRespostaActions;
  const synced = useSelector(getFormularioControleRespostaIsSynced);
  const countMunicipiosSynced = useSelector(getCountMunicipiosSynced);
  const municipiosSincronizados = useSelector(getMunicipiosSincronizados);

  const sincronizarFormulariosControleRespostas = (
    items: FormularioRespostaControle[]
  ) => {
    appDispatch(sync(items));
  };

  const removerMunicipio = (municipioId: number) => {
    appDispatch(removeMunicipio(municipioId));
  };

  const getFormularioRespostaControle =
    formularioApi.listRespostasControleByMunicipio;

  const getFormulariosRespostaControle = async (municipioId: number) => {
    if (isOnline) {
      const dados = await getFormularioRespostaControle(municipioId);
      return dados;
    }

    return listaFormularioControleResposta.filter(
      (f) => f.municipio.id === municipioId
    );
  };

  return {
    getFormularioRespostaControle,
    sincronizarFormulariosControleRespostas,
    removerMunicipio,
    listaFormularioControleResposta,
    municipiosSincronizados,
    synced,
    getFormulariosRespostaControle,
    countMunicipiosSynced,
  };
};
